import React from 'react';

const BarChartIcon = ({ size }: { size: number }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} fill="none" viewBox="0 0 431 257">
      <g clipPath="url(#clip0_6710_81466)">
        <path stroke="#E5E8EB" strokeWidth="0.771" d="M62.069 197.607L399.764 197.607"></path>
        <path
          stroke="#E5E8EB"
          strokeDasharray="0.77 0.77"
          strokeWidth="0.771"
          d="M62.069 157.515L399.764 157.515"
        ></path>
        <path
          stroke="#E5E8EB"
          strokeDasharray="0.77 0.77"
          strokeWidth="0.771"
          d="M62.069 117.424L399.764 117.424"
        ></path>
        <path
          stroke="#E5E8EB"
          strokeDasharray="0.77 0.77"
          strokeWidth="0.771"
          d="M62.069 77.332L399.764 77.332"
        ></path>
        <path
          stroke="#E5E8EB"
          strokeDasharray="0.77 0.77"
          strokeWidth="0.771"
          d="M62.069 37.24L399.764 37.24"
        ></path>
        <path
          fill="#5D697E"
          d="M46.186 39.081c1.037 0 1.776-.582 1.776-1.402v-.007c0-.603-.424-1.105-1.05-1.25v-.014c.535-.166.874-.572.874-1.087v-.007c0-.739-.675-1.284-1.6-1.284s-1.599.545-1.599 1.284v.007c0 .515.339.921.874 1.087v.014c-.627.145-1.05.647-1.05 1.25v.007c0 .82.739 1.402 1.775 1.402zm0-2.9c-.59 0-.992-.335-.992-.81v-.007c0-.474.403-.81.992-.81.59 0 .993.336.993.81v.007c0 .475-.403.81-.993.81zm0 2.368c-.674 0-1.155-.38-1.155-.908v-.006c0-.536.478-.919 1.155-.919.678 0 1.156.383 1.156.919v.006c0 .529-.481.908-1.156.908zm4.008.532c1.125 0 1.799-.972 1.799-2.524v-.007c0-1.551-.674-2.52-1.8-2.52-1.124 0-1.791.969-1.791 2.52v.007c0 1.552.667 2.524 1.792 2.524zm0-.532c-.745 0-1.18-.765-1.18-1.992v-.007c0-1.226.434-1.985 1.18-1.985.745 0 1.186.759 1.186 1.985v.007c0 1.227-.44 1.992-1.186 1.992zm4.034.532c1.125 0 1.8-.972 1.8-2.524v-.007c0-1.551-.675-2.52-1.8-2.52-1.124 0-1.792.969-1.792 2.52v.007c0 1.552.668 2.524 1.792 2.524zm0-.532c-.745 0-1.179-.765-1.179-1.992v-.007c0-1.226.434-1.985 1.18-1.985.745 0 1.185.759 1.185 1.985v.007c0 1.227-.44 1.992-1.186 1.992zM46.378 79.944c1 0 1.731-.698 1.731-1.66v-.007c0-.929-.69-1.617-1.623-1.617-.663 0-1.165.353-1.361.787h-.014c0-.038 0-.072.003-.106.028-1.026.387-1.91 1.298-1.91.502 0 .85.25.996.654l.014.037h.62l-.01-.044c-.163-.712-.783-1.186-1.613-1.186-1.196 0-1.898.962-1.898 2.609v.006c0 1.813.956 2.437 1.857 2.437zm-1.121-1.667v-.004c0-.623.484-1.077 1.125-1.077.643 0 1.107.457 1.107 1.094v.007c0 .617-.494 1.105-1.118 1.105a1.11 1.11 0 01-1.114-1.125zm5.166 1.667c1.125 0 1.799-.973 1.799-2.525v-.006c0-1.552-.674-2.521-1.8-2.521-1.124 0-1.791.969-1.791 2.52v.007c0 1.552.667 2.525 1.792 2.525zm0-.532c-.745 0-1.18-.766-1.18-1.993v-.006c0-1.227.434-1.986 1.18-1.986.745 0 1.186.76 1.186 1.986v.006c0 1.227-.44 1.993-1.186 1.993zm4.035.532c1.124 0 1.799-.973 1.799-2.525v-.006c0-1.552-.675-2.521-1.8-2.521-1.124 0-1.792.969-1.792 2.52v.007c0 1.552.668 2.525 1.793 2.525zm0-.532c-.746 0-1.18-.766-1.18-1.993v-.006c0-1.227.434-1.986 1.18-1.986.745 0 1.185.76 1.185 1.986v.006c0 1.227-.44 1.993-1.185 1.993zM72.588 208.618v-4.889h-1.846c-.918 0-1.566.617-1.566 1.498v.006c0 .725.458 1.271 1.15 1.43l-1.404 1.955h.725l1.349-1.88h.983v1.88h.61zm-.61-2.429h-1.077c-.698 0-1.101-.346-1.101-.956v-.006c0-.607.4-.949 1.101-.949h1.078v1.911zm3.676 2.429h.59v-3.524h-.59v1.454h-1.725v-1.454h-.59v3.524h.59v-1.582h1.725v1.582zm1.246 0h1.518c.749 0 1.21-.389 1.21-1.01v-.006c0-.431-.292-.742-.736-.803v-.027c.326-.068.58-.4.58-.763v-.006c0-.56-.403-.909-1.064-.909H76.9v3.524zm.59-2.05v-.986h.83c.369 0 .566.166.566.481v.007c0 .339-.21.498-.654.498h-.742zm0 1.562v-1.074h.772c.515 0 .763.17.763.532v.007c0 .352-.23.535-.658.535h-.877zm5.575.569c1.125 0 1.8-.972 1.8-2.524v-.006c0-1.552-.675-2.521-1.8-2.521s-1.792.969-1.792 2.521v.006c0 1.552.667 2.524 1.792 2.524zm0-.531c-.745 0-1.179-.766-1.179-1.993v-.006c0-1.227.434-1.986 1.18-1.986.745 0 1.185.759 1.185 1.986v.006c0 1.227-.44 1.993-1.186 1.993zm3.51.45h.59v-4.889h-.597l-1.301.935v.613l1.294-.901h.014v4.242zM100.698 208.699c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.793.969-1.793 2.521v.006c0 1.552.668 2.524 1.793 2.524zm0-.531c-.746 0-1.18-.766-1.18-1.993v-.006c0-1.227.434-1.986 1.18-1.986.745 0 1.186.759 1.186 1.986v.006c0 1.227-.441 1.993-1.186 1.993zm2.262.45h3.226v-.542h-2.389v-.013l1.162-1.193c.898-.918 1.146-1.321 1.146-1.857v-.007c0-.765-.648-1.358-1.532-1.358-.911 0-1.643.627-1.643 1.474v.02h.589v-.017c0-.525.454-.945 1.064-.945.532 0 .908.359.912.857v.007c0 .406-.153.671-.813 1.358l-1.722 1.796v.42zM123.706 208.699c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.793.969-1.793 2.521v.006c0 1.552.668 2.524 1.793 2.524zm0-.531c-.746 0-1.179-.766-1.179-1.993v-.006c0-1.227.433-1.986 1.179-1.986.745 0 1.185.759 1.185 1.986v.006c0 1.227-.44 1.993-1.185 1.993zm3.977.531c.979 0 1.697-.603 1.697-1.419v-.007c0-.695-.484-1.138-1.196-1.199v-.014c.61-.129 1.037-.542 1.037-1.145v-.007c0-.742-.613-1.26-1.545-1.26-.915 0-1.545.532-1.623 1.328l-.003.034h.586l.003-.034c.051-.495.461-.8 1.037-.8.596 0 .932.295.932.807v.006c0 .488-.407.847-.99.847h-.586v.515h.613c.685 0 1.115.336 1.115.936v.006c0 .519-.437.878-1.077.878-.651 0-1.091-.332-1.142-.813l-.004-.034h-.586l.004.041c.064.772.718 1.334 1.728 1.334zM146.791 208.699c1.125 0 1.8-.972 1.8-2.524v-.006c0-1.552-.675-2.521-1.8-2.521-1.124 0-1.792.969-1.792 2.521v.006c0 1.552.668 2.524 1.792 2.524zm0-.531c-.745 0-1.179-.766-1.179-1.993v-.006c0-1.227.434-1.986 1.179-1.986.746 0 1.186.759 1.186 1.986v.006c0 1.227-.44 1.993-1.186 1.993zm4.655.45h.59v-1.016h.691v-.536h-.691v-3.337h-.902l-2.144 3.32v.553h2.456v1.016zm-1.853-1.552v-.013l1.833-2.802h.02v2.815h-1.853zM169.989 208.699c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.793.969-1.793 2.521v.006c0 1.552.668 2.524 1.793 2.524zm0-.531c-.746 0-1.179-.766-1.179-1.993v-.006c0-1.227.433-1.986 1.179-1.986.745 0 1.185.759 1.185 1.986v.006c0 1.227-.44 1.993-1.185 1.993zm4.011.531c1.016 0 1.738-.684 1.741-1.663v-.007c0-.938-.678-1.619-1.616-1.619-.474 0-.881.176-1.111.504H173l.166-1.643h2.297v-.542h-2.798l-.251 2.789h.539c.064-.112.142-.207.23-.288.217-.197.501-.295.833-.295.648 0 1.112.461 1.115 1.104v.007c0 .657-.461 1.118-1.125 1.118-.586 0-1.02-.369-1.081-.854l-.003-.027h-.6l.004.038c.071.796.738 1.378 1.674 1.378z"
        ></path>
        <path
          fill="#5D697E"
          d="M193.007 208.699c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.793.969-1.793 2.521v.006c0 1.552.668 2.524 1.793 2.524zm0-.531c-.746 0-1.179-.766-1.179-1.993v-.006c0-1.227.433-1.986 1.179-1.986.745 0 1.186.759 1.186 1.986v.006c0 1.227-.441 1.993-1.186 1.993zm4.099.531c.999 0 1.731-.697 1.731-1.66v-.006c0-.929-.691-1.617-1.623-1.617-.664 0-1.165.353-1.362.786h-.013c0-.037 0-.071.003-.105.027-1.026.386-1.911 1.298-1.911.501 0 .85.251.996.654l.013.038h.62l-.01-.044c-.163-.712-.783-1.186-1.613-1.186-1.196 0-1.897.962-1.897 2.609v.006c0 1.813.955 2.436 1.857 2.436zm-1.122-1.666v-.004c0-.623.485-1.077 1.125-1.077.644 0 1.108.457 1.108 1.094v.007c0 .616-.495 1.104-1.118 1.104a1.11 1.11 0 01-1.115-1.124zM216.448 208.699c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.792.969-1.792 2.521v.006c0 1.552.667 2.524 1.792 2.524zm0-.531c-.745 0-1.179-.766-1.179-1.993v-.006c0-1.227.434-1.986 1.179-1.986.746 0 1.186.759 1.186 1.986v.006c0 1.227-.44 1.993-1.186 1.993zm2.476.45h.641l2.175-4.323v-.566h-3.236v.542h2.633v.014l-2.213 4.333z"
          opacity="0.3"
        ></path>
        <path
          fill="#5D697E"
          d="M239.327 208.699c1.125 0 1.8-.972 1.8-2.524v-.006c0-1.552-.675-2.521-1.8-2.521-1.124 0-1.792.969-1.792 2.521v.006c0 1.552.668 2.524 1.792 2.524zm0-.531c-.745 0-1.179-.766-1.179-1.993v-.006c0-1.227.434-1.986 1.179-1.986.746 0 1.186.759 1.186 1.986v.006c0 1.227-.44 1.993-1.186 1.993zm4.015.531c1.037 0 1.775-.582 1.775-1.402v-.007c0-.603-.423-1.105-1.05-1.25v-.014c.535-.166.874-.572.874-1.087v-.007c0-.739-.674-1.284-1.599-1.284-.925 0-1.599.545-1.599 1.284v.007c0 .515.338.921.874 1.087v.014c-.627.145-1.051.647-1.051 1.25v.007c0 .82.739 1.402 1.776 1.402zm0-2.9c-.59 0-.993-.335-.993-.81v-.006c0-.475.403-.81.993-.81.589 0 .992.335.992.81v.006c0 .475-.403.81-.992.81zm0 2.369c-.674 0-1.156-.38-1.156-.908v-.007c0-.536.478-.918 1.156-.918.677 0 1.155.382 1.155.918v.007c0 .528-.481.908-1.155.908zM262.396 208.699c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.792.969-1.792 2.521v.006c0 1.552.667 2.524 1.792 2.524zm0-.531c-.746 0-1.179-.766-1.179-1.993v-.006c0-1.227.433-1.986 1.179-1.986.745 0 1.186.759 1.186 1.986v.006c0 1.227-.441 1.993-1.186 1.993zm4.051-4.52c-.999 0-1.731.698-1.731 1.66v.007c0 .928.691 1.616 1.623 1.616.664 0 1.166-.353 1.362-.786h.014c0 .037 0 .071-.004.105-.027 1.026-.386 1.911-1.297 1.911-.502 0-.851-.251-.997-.654l-.013-.037h-.62l.01.044c.163.711.783 1.185 1.613 1.185 1.196 0 1.897-.962 1.897-2.608v-.007c0-1.813-.955-2.436-1.857-2.436zm-.003 2.748c-.644 0-1.108-.458-1.108-1.095v-.007c0-.616.495-1.104 1.118-1.104a1.11 1.11 0 011.115 1.125v.003c0 .624-.485 1.078-1.125 1.078zM285.671 208.618h.59v-4.889h-.596l-1.301.935v.613l1.294-.901h.013v4.242zm3.361.081c1.125 0 1.799-.972 1.799-2.524v-.006c0-1.552-.674-2.521-1.799-2.521s-1.793.969-1.793 2.521v.006c0 1.552.668 2.524 1.793 2.524zm0-.531c-.746 0-1.179-.766-1.179-1.993v-.006c0-1.227.433-1.986 1.179-1.986.745 0 1.186.759 1.186 1.986v.006c0 1.227-.441 1.993-1.186 1.993zM309.367 208.618h.59v-4.889h-.597l-1.301.935v.613l1.295-.901h.013v4.242zm2.903 0h.59v-4.889h-.597l-1.301.935v.613l1.295-.901h.013v4.242zM332.07 208.618h.59v-4.889h-.597l-1.301.935v.613l1.295-.901h.013v4.242zm1.656 0h3.226v-.542h-2.389v-.013l1.162-1.193c.898-.918 1.145-1.321 1.145-1.857v-.007c0-.765-.647-1.358-1.531-1.358-.911 0-1.643.627-1.643 1.474v.02h.589v-.017c0-.525.454-.945 1.064-.945.532 0 .908.359.912.857v.007c0 .406-.153.671-.814 1.358l-1.721 1.796v.42z"
        ></path>
        <path
          fill="#5D697E"
          d="M355.111 208.618h.59v-4.889h-.596l-1.301.935v.613l1.294-.901h.013v4.242zm3.303.081c.979 0 1.698-.603 1.698-1.419v-.007c0-.695-.485-1.138-1.196-1.199v-.014c.61-.129 1.036-.542 1.036-1.145v-.007c0-.742-.613-1.26-1.545-1.26-.914 0-1.545.532-1.623 1.328l-.003.034h.586l.004-.034c.05-.495.46-.8 1.036-.8.597 0 .932.295.932.807v.006c0 .488-.406.847-.989.847h-.586v.515h.613c.684 0 1.115.336 1.115.936v.006c0 .519-.437.878-1.078.878-.65 0-1.091-.332-1.142-.813l-.003-.034h-.586l.003.041c.065.772.719 1.334 1.728 1.334zM378.197 208.618h.59v-4.889h-.597l-1.301.935v.613l1.295-.901h.013v4.242zm3.981 0h.589v-1.016h.691v-.536h-.691v-3.337h-.901l-2.145 3.32v.553h2.457v1.016zm-1.854-1.552v-.013l1.833-2.802h.021v2.815h-1.854z"
          opacity="0.3"
        ></path>
        <path
          fill="#5D697E"
          d="M46.793 119.954h.59v-1.016h.69v-.536h-.69v-3.337h-.902l-2.145 3.32v.553h2.457v1.016zm-1.853-1.552v-.013l1.833-2.802h.02v2.815H44.94zm5.254 1.633c1.125 0 1.799-.972 1.799-2.524v-.007c0-1.551-.674-2.52-1.8-2.52-1.124 0-1.791.969-1.791 2.52v.007c0 1.552.667 2.524 1.792 2.524zm0-.532c-.745 0-1.18-.765-1.18-1.992v-.007c0-1.226.434-1.985 1.18-1.985.745 0 1.186.759 1.186 1.985v.007c0 1.227-.44 1.992-1.186 1.992zm4.034.532c1.125 0 1.8-.972 1.8-2.524v-.007c0-1.551-.675-2.52-1.8-2.52-1.124 0-1.792.969-1.792 2.52v.007c0 1.552.668 2.524 1.792 2.524zm0-.532c-.745 0-1.179-.765-1.179-1.992v-.007c0-1.226.434-1.985 1.18-1.985.745 0 1.185.759 1.185 1.985v.007c0 1.227-.44 1.992-1.186 1.992zM44.733 159.274h3.225v-.542H45.57v-.013l1.162-1.193c.898-.918 1.145-1.321 1.145-1.857v-.006c0-.766-.647-1.359-1.531-1.359-.912 0-1.644.627-1.644 1.474v.02h.59v-.017c0-.525.454-.945 1.064-.945.532 0 .908.359.911.857v.007c0 .406-.152.671-.813 1.359l-1.721 1.795v.42zm5.46.082c1.126 0 1.8-.973 1.8-2.524v-.007c0-1.552-.674-2.521-1.8-2.521-1.124 0-1.791.969-1.791 2.521v.007c0 1.551.667 2.524 1.792 2.524zm0-.532c-.744 0-1.178-.766-1.178-1.992v-.007c0-1.227.434-1.986 1.179-1.986.745 0 1.186.759 1.186 1.986v.007c0 1.226-.44 1.992-1.186 1.992zm4.035.532c1.125 0 1.8-.973 1.8-2.524v-.007c0-1.552-.675-2.521-1.8-2.521-1.124 0-1.792.969-1.792 2.521v.007c0 1.551.668 2.524 1.792 2.524zm0-.532c-.745 0-1.179-.766-1.179-1.992v-.007c0-1.227.434-1.986 1.18-1.986.745 0 1.185.759 1.185 1.986v.007c0 1.226-.44 1.992-1.186 1.992zM53.938 198.677c1.125 0 1.8-.972 1.8-2.524v-.007c0-1.552-.675-2.521-1.8-2.521-1.124 0-1.792.969-1.792 2.521v.007c0 1.552.668 2.524 1.792 2.524zm0-.532c-.745 0-1.179-.766-1.179-1.992v-.007c0-1.226.434-1.985 1.18-1.985.745 0 1.185.759 1.185 1.985v.007c0 1.226-.44 1.992-1.186 1.992z"
        ></path>
        <path
          fill="url(#paint0_linear_6710_81466)"
          d="M69.55 78.489a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v118.733h-8V78.489z"
        ></path>
        <path
          fill="url(#paint1_linear_6710_81466)"
          d="M92.68 96.221a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v101h-8v-101z"
        ></path>
        <path
          fill="url(#paint2_linear_6710_81466)"
          d="M116.58 137.083a3.854 3.854 0 013.855-3.854h.29a3.854 3.854 0 013.855 3.854v60.138h-8v-60.138z"
        ></path>
        <path
          fill="url(#paint3_linear_6710_81466)"
          d="M139.71 74.634a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v122.588h-8V74.634z"
        ></path>
        <path
          fill="url(#paint4_linear_6710_81466)"
          d="M162.84 137.083a3.854 3.854 0 013.855-3.854h.29a3.854 3.854 0 013.855 3.854v60.138h-8v-60.138z"
        ></path>
        <path
          fill="url(#paint5_linear_6710_81466)"
          d="M185.97 78.489a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v118.733h-8V78.489z"
        ></path>
        <path
          fill="url(#paint6_linear_6710_81466)"
          d="M209.1 122.435a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v74.786h-8v-74.786z"
        ></path>
        <path
          fill="url(#paint7_linear_6710_81466)"
          d="M233 41.481a3.855 3.855 0 013.855-3.855h.29A3.855 3.855 0 01241 41.481v155.74h-8V41.481z"
        ></path>
        <path
          fill="url(#paint8_linear_6710_81466)"
          d="M256.901 122.435a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v74.786h-8v-74.786z"
        ></path>
        <path
          fill="url(#paint9_linear_6710_81466)"
          d="M280.031 63.84a3.855 3.855 0 013.855-3.856h.29a3.855 3.855 0 013.855 3.855v133.382h-8V63.839z"
        ></path>
        <path
          fill="url(#paint10_linear_6710_81466)"
          d="M303.161 74.634a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v122.588h-8V74.634z"
        ></path>
        <path
          fill="url(#paint11_linear_6710_81466)"
          d="M326.29 130.145a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v67.076h-8v-67.076z"
        ></path>
        <path
          fill="url(#paint12_linear_6710_81466)"
          d="M349.42 131.687a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v65.534h-8v-65.534z"
        ></path>
        <path
          fill="url(#paint13_linear_6710_81466)"
          d="M371.779 66.153a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v131.069h-8V66.152z"
        ></path>
        <path
          fill="url(#paint14_linear_6710_81466)"
          d="M78.55 128.489a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v68.733h-8v-68.733z"
        ></path>
        <path
          fill="url(#paint15_linear_6710_81466)"
          d="M101.68 146.221a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v51h-8v-51z"
        ></path>
        <path
          fill="url(#paint16_linear_6710_81466)"
          d="M126 136.855a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855V197h-8v-60.145z"
        ></path>
        <path
          fill="url(#paint17_linear_6710_81466)"
          d="M148.71 124.634a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v72.588h-8v-72.588z"
        ></path>
        <path
          fill="url(#paint18_linear_6710_81466)"
          d="M172 161.855a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855V197h-8v-35.145z"
        ></path>
        <path
          fill="url(#paint19_linear_6710_81466)"
          d="M194.97 128.489a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v68.733h-8v-68.733z"
        ></path>
        <path
          fill="url(#paint20_linear_6710_81466)"
          d="M218.1 172.435a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v24.786h-8v-24.786z"
        ></path>
        <path
          fill="url(#paint21_linear_6710_81466)"
          d="M242 91.48a3.855 3.855 0 013.855-3.854h.29A3.855 3.855 0 01250 91.481v105.74h-8V91.481z"
        ></path>
        <path
          fill="url(#paint22_linear_6710_81466)"
          d="M265.901 172.435a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v24.786h-8v-24.786z"
        ></path>
        <path
          fill="url(#paint23_linear_6710_81466)"
          d="M289.031 113.839a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v83.382h-8v-83.382z"
        ></path>
        <path
          fill="url(#paint24_linear_6710_81466)"
          d="M312.161 124.634a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v72.588h-8v-72.588z"
        ></path>
        <path
          fill="url(#paint25_linear_6710_81466)"
          d="M335.29 180.145a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v17.076h-8v-17.076z"
        ></path>
        <path
          fill="url(#paint26_linear_6710_81466)"
          d="M358.42 181.687a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v15.534h-8v-15.534z"
        ></path>
        <path
          fill="url(#paint27_linear_6710_81466)"
          d="M380.779 116.153a3.855 3.855 0 013.855-3.855h.29a3.855 3.855 0 013.855 3.855v81.069h-8v-81.069z"
        ></path>
      </g>
      <path
        fill="#2E3842"
        d="M29 158.271v-3.109c0-1.649-.827-2.643-2.186-2.643h-.01c-1.021 0-1.779.714-1.891 1.815h-.022c-.118-.816-.875-1.439-1.692-1.439h-.01c-1.171 0-1.94.908-1.94 2.283v3.093H29zm-6.768-2.803c0-.87.393-1.37 1.102-1.37h.01c.779 0 1.209.575 1.209 1.633v1.337h-2.32v-1.6zm3.25.021c0-1.149.43-1.74 1.262-1.74h.01c.828 0 1.263.58 1.263 1.654v1.665h-2.535v-1.579zm3.63-6.1c0-1.37-.816-2.245-1.713-2.423l-.059-.016v1.107l.043.016c.425.145.78.601.78 1.289 0 .924-.624 1.509-1.693 1.531v-4.002h-.392c-1.697 0-2.836.972-2.836 2.557 0 1.584 1.182 2.605 2.949 2.605h.005c1.784 0 2.917-1.005 2.917-2.664zm-4.92.053c0-.757.479-1.31 1.456-1.401v2.836c-.945-.108-1.455-.683-1.455-1.435zm6.688-3.275v-1.16h-2.83v-.027c.655-.333 1.063-.983 1.063-1.783 0-1.418-1.133-2.347-2.933-2.347h-.005c-1.805 0-2.933.924-2.933 2.363 0 .806.408 1.429 1.08 1.767v.027h-.972v1.16h7.53zm-2.766-2.653c0 .875-.763 1.498-1.934 1.498h-.005c-1.177 0-1.94-.617-1.94-1.498 0-.913.737-1.483 1.94-1.483h.005c1.193 0 1.934.57 1.934 1.483zm-4.764-7.492v4.7h.923v-1.767H29v-1.166h-4.727v-1.767h-.923zm5.65-.573v-1.144l-3.97-2.595v-.048H29v-1.155h-5.65v1.144l3.953 2.595v.053H23.35v1.15H29zm-2.519-7.277L29 126.093v-1.434l-2.997 2.476-2.653-2.379v1.369l2.33 2.047v.204h-2.33v1.16H29v-1.16h-2.519v-.204zm2.621-5.51c0-.752-.387-1.402-.994-1.729v-.027H29v-1.16h-3.894c-1.133 0-1.864.875-1.864 2.256 0 1.391.747 2.234 1.719 2.315l.059.005v-1.096l-.048-.011c-.452-.096-.768-.51-.768-1.181 0-.72.376-1.128.999-1.128h.424l.091 1.541c.08 1.338.682 2.1 1.665 2.1h.011c1.015 0 1.708-.757 1.708-1.885zm-1.735.715h-.01c-.479 0-.785-.387-.828-1.085l-.086-1.386h.44c.737 0 1.29.623 1.29 1.439 0 .623-.312 1.032-.806 1.032zm-.902-6.337l-2.192-.156v-1.95H29v-1.16h-5.65v4.13l3.056.205c1.026.069 1.611.268 1.611.854 0 .145-.021.247-.037.3h1.015c.026-.08.059-.241.059-.462 0-1.267-1.005-1.648-2.59-1.761zM29 112.798v-2.235c0-1.305-.757-2.148-1.95-2.148h-.01c-1.188 0-1.945.843-1.945 2.148v1.075H23.35v1.16H29zm-2.986-2.122c0-.655.402-1.074 1.026-1.074h.01c.623 0 1.031.413 1.031 1.074v.962h-2.067v-.962zM29 104.017v-1.16h-5.65v1.16h2.277v2.546H23.35v1.16H29v-1.16h-2.455v-2.546H29zm.102-3.791c0-.752-.387-1.402-.994-1.73v-.026H29v-1.16h-3.894c-1.133 0-1.864.875-1.864 2.255 0 1.392.747 2.235 1.719 2.315l.059.006v-1.096l-.048-.011c-.452-.096-.768-.51-.768-1.181 0-.72.376-1.128.999-1.128h.424l.091 1.541c.08 1.338.682 2.1 1.665 2.1h.011c1.015 0 1.708-.757 1.708-1.885zm-1.735.714h-.01c-.479 0-.785-.386-.828-1.084l-.086-1.386h.44c.737 0 1.29.623 1.29 1.44 0 .622-.312 1.03-.806 1.03zM29 93.137v-1.154h-5.65v2.293c0 1.321.73 2.18 1.901 2.18h.01c.785 0 1.37-.483 1.601-1.267L29 96.731v-1.322l-1.939-1.364v-.908H29zm-2.836 1.08c0 .655-.376 1.063-.908 1.063h-.01c-.613 0-.978-.403-.978-1.063v-1.08h1.896v1.08zm2.949-7.587c0-1.617-1.117-2.68-2.938-2.68h-.01c-1.811 0-2.923 1.074-2.923 2.68s1.117 2.68 2.922 2.68h.01c1.816 0 2.939-1.058 2.939-2.68zm-.972-.006c0 .908-.715 1.499-1.966 1.499h-.01c-1.236 0-1.95-.596-1.95-1.493 0-.903.714-1.499 1.95-1.499h.01c1.246 0 1.966.586 1.966 1.493zm.972-5.82c0-1.36-.87-2.305-2.004-2.429l-.037-.005v1.112l.043.01c.612.14 1.026.591 1.026 1.306 0 .902-.725 1.498-1.96 1.498h-.006c-1.209 0-1.96-.585-1.96-1.488 0-.757.467-1.187 1.02-1.31l.043-.01V78.38l-.038.005c-1.063.097-1.998.978-1.998 2.428 0 1.617 1.133 2.67 2.922 2.67h.005c1.81 0 2.944-1.032 2.944-2.68zM29 77.726v-2.235c0-1.305-.757-2.148-1.95-2.148h-.01c-1.188 0-1.945.843-1.945 2.148v1.074H23.35v1.16H29zm-2.986-2.122c0-.655.402-1.074 1.026-1.074h.01c.623 0 1.031.413 1.031 1.074v.961h-2.067v-.961zM411.531 171.192H410v-5.462h1.531v-1.101h-2.568v.967h-6.713v5.048l4.699.285c1.026.059 1.687.252 2.014.806v.564h2.568v-1.107zm-4.523-1.38l-3.722-.237v-2.776h5.677v3.545h-.043c-.44-.371-1.036-.478-1.912-.532zm3.105-8.26c0-1.617-1.117-2.68-2.938-2.68h-.011c-1.81 0-2.922 1.074-2.922 2.68s1.117 2.68 2.922 2.68h.011c1.815 0 2.938-1.058 2.938-2.68zm-.972-.005c0 .907-.715 1.498-1.966 1.498h-.011c-1.235 0-1.95-.596-1.95-1.493 0-.902.715-1.498 1.95-1.498h.011c1.246 0 1.966.585 1.966 1.493zm.859-3.394v-1.16h-4.727v-2.492H410v-1.166h-5.65v4.818H410zm.113-8.222c0-1.616-1.117-2.68-2.938-2.68h-.011c-1.81 0-2.922 1.074-2.922 2.68s1.117 2.68 2.922 2.68h.011c1.815 0 2.938-1.058 2.938-2.68zm-.972-.005c0 .908-.715 1.498-1.966 1.498h-.011c-1.235 0-1.95-.596-1.95-1.493 0-.902.715-1.498 1.95-1.498h.011c1.246 0 1.966.585 1.966 1.493zm-1.676-4.946l-2.192-.156v-1.949H410v-1.16h-5.65v4.13l3.056.204c1.026.07 1.611.269 1.611.854 0 .145-.021.247-.038.301h1.016c.026-.081.059-.242.059-.462 0-1.268-1.005-1.649-2.589-1.762zm2.535-7.948v-1.16h-5.65v1.16h2.277v2.546h-2.277v1.16H410v-1.16h-2.455v-2.546H410zm0-2.131v-1.144l-3.969-2.595v-.048H410v-1.155h-5.65v1.144l3.953 2.595v.053h-3.953v1.15H410zm-5.65-10.21v4.7h.923v-1.767H410v-1.166h-4.727v-1.767h-.923zm5.763-2.877c0-1.37-.817-2.246-1.714-2.423l-.059-.016v1.107l.043.016c.425.145.779.601.779 1.289 0 .924-.623 1.509-1.692 1.53v-4.001h-.392c-1.697 0-2.836.972-2.836 2.557 0 1.584 1.182 2.605 2.949 2.605h.005c1.783 0 2.917-1.005 2.917-2.664zm-4.92.053c0-.757.478-1.31 1.455-1.402v2.836c-.945-.107-1.455-.682-1.455-1.434zm2.272-4.827l-2.192-.156v-1.95H410v-1.16h-5.65v4.13l3.056.205c1.026.069 1.611.268 1.611.854 0 .145-.021.247-.038.3h1.016c.026-.08.059-.241.059-.462 0-1.267-1.005-1.648-2.589-1.761zm2.535-4.242v-2.235c0-1.305-.757-2.148-1.95-2.148h-.01c-1.187 0-1.945.843-1.945 2.148v1.074h-1.745v1.161H410zm-2.986-2.122c0-.655.403-1.074 1.026-1.074h.01c.623 0 1.032.413 1.032 1.074v.961h-2.068v-.961zm2.986-6.659v-1.16h-5.65v1.16h2.277v2.546h-2.277v1.16H410v-1.16h-2.455v-2.546H410zm.102-3.791c0-.752-.387-1.402-.994-1.73v-.026H410v-1.16h-3.894c-1.133 0-1.864.875-1.864 2.255 0 1.392.747 2.235 1.719 2.315l.059.006v-1.096l-.048-.011c-.451-.096-.768-.51-.768-1.181 0-.72.376-1.128.999-1.128h.424l.091 1.541c.081 1.338.682 2.1 1.665 2.1h.011c1.015 0 1.708-.757 1.708-1.885zm-1.735.714h-.011c-.478 0-.784-.386-.827-1.084l-.086-1.386h.441c.736 0 1.289.623 1.289 1.44 0 .622-.312 1.03-.806 1.03zM410 93.137v-1.154h-5.65v2.293c0 1.321.73 2.18 1.901 2.18h.011c.784 0 1.369-.483 1.6-1.267L410 96.731v-1.322l-1.939-1.364v-.908H410zm-2.836 1.08c0 .655-.376 1.063-.908 1.063h-.01c-.613 0-.978-.403-.978-1.063v-1.08h1.896v1.08zm2.949-7.587c0-1.617-1.117-2.68-2.938-2.68h-.011c-1.81 0-2.922 1.074-2.922 2.68s1.117 2.68 2.922 2.68h.011c1.815 0 2.938-1.058 2.938-2.68zm-.972-.006c0 .908-.715 1.499-1.966 1.499h-.011c-1.235 0-1.95-.596-1.95-1.493 0-.903.715-1.499 1.95-1.499h.011c1.246 0 1.966.586 1.966 1.493zm.972-5.82c0-1.36-.87-2.305-2.004-2.429l-.037-.005v1.112l.043.01c.612.14 1.026.591 1.026 1.306 0 .902-.725 1.498-1.961 1.498h-.005c-1.209 0-1.961-.585-1.961-1.488 0-.757.468-1.187 1.021-1.31l.043-.01V78.38l-.038.005c-1.063.097-1.998.978-1.998 2.428 0 1.617 1.133 2.67 2.922 2.67h.005c1.81 0 2.944-1.032 2.944-2.68zM410 77.726v-2.235c0-1.305-.757-2.148-1.95-2.148h-.01c-1.187 0-1.945.843-1.945 2.148v1.074h-1.745v1.16H410zm-2.986-2.122c0-.655.402-1.074 1.026-1.074h.01c.623 0 1.032.413 1.032 1.074v.961h-2.068v-.961zM187.228 235v-6.714h3.534v-1.036h-4.737V235h1.203zm5.66.113c1.617 0 2.68-1.117 2.68-2.938v-.011c0-1.81-1.074-2.922-2.68-2.922s-2.68 1.117-2.68 2.922v.011c0 1.815 1.058 2.938 2.68 2.938zm.006-.972c-.908 0-1.499-.715-1.499-1.966v-.011c0-1.235.596-1.95 1.493-1.95.903 0 1.499.715 1.499 1.95v.011c0 1.246-.586 1.966-1.493 1.966zm3.393 2.739h1.16v-2.831h.027c.333.656.983 1.064 1.783 1.064 1.418 0 2.347-1.134 2.347-2.933v-.005c0-1.805-.923-2.933-2.363-2.933-.805 0-1.428.408-1.767 1.08h-.027v-.972h-1.16v7.53zm2.653-2.766c-.875 0-1.498-.763-1.498-1.934v-.005c0-1.176.618-1.939 1.498-1.939.914 0 1.483.736 1.483 1.939v.005c0 1.193-.569 1.934-1.483 1.934zm3.389.886h1.144l2.594-3.969h.048V235h1.155v-5.65h-1.144l-2.594 3.953h-.054v-3.953h-1.149V235zm7.948.113c1.385 0 2.304-.704 2.304-1.757v-.01c0-.661-.408-1.112-1.155-1.263v-.042c.607-.14.999-.618.999-1.225v-.011c0-.967-.795-1.563-2.095-1.563-1.273 0-2.105.602-2.239 1.606l-.006.043h1.107l.005-.037c.086-.43.51-.693 1.117-.693.613 0 .978.284.978.768v.01c0 .505-.349.763-1.031.763h-.811v.843h.816c.784 0 1.16.258 1.16.801v.01c0 .516-.44.833-1.155.833-.639 0-1.058-.247-1.187-.704l-.016-.053h-1.139l.006.048c.113.999 1.02 1.633 2.342 1.633zm5.477 0c1.617 0 2.68-1.117 2.68-2.938v-.011c0-1.81-1.074-2.922-2.68-2.922s-2.68 1.117-2.68 2.922v.011c0 1.815 1.058 2.938 2.68 2.938zm.005-.972c-.907 0-1.498-.715-1.498-1.966v-.011c0-1.235.596-1.95 1.493-1.95.902 0 1.499.715 1.499 1.95v.011c0 1.246-.586 1.966-1.494 1.966zm7.1.859h1.16v-5.65h-1.16v2.277h-2.546v-2.277h-1.16V235h1.16v-2.455h2.546V235zm6.428-5.65h-4.7v.923h1.767V235h1.166v-4.727h1.767v-.923zm2.051 5.752c.752 0 1.402-.387 1.729-.994h.027V235h1.16v-3.894c0-1.133-.875-1.864-2.256-1.864-1.391 0-2.234.747-2.315 1.719l-.005.059h1.096l.011-.048c.096-.451.51-.768 1.181-.768.72 0 1.128.376 1.128.999v.424l-1.541.091c-1.338.081-2.1.682-2.1 1.665v.011c0 1.015.757 1.708 1.885 1.708zm-.715-1.735v-.011c0-.478.387-.784 1.085-.827l1.386-.086v.441c0 .736-.623 1.289-1.439 1.289-.623 0-1.032-.312-1.032-.806zm6.337-.902l.156-2.192h1.95V235h1.16v-5.65h-4.13l-.205 3.056c-.069 1.026-.268 1.611-.854 1.611-.145 0-.247-.021-.3-.038v1.016c.08.026.241.059.462.059 1.267 0 1.648-1.005 1.761-2.589zm4.242 2.535h2.235c1.305 0 2.148-.757 2.148-1.95v-.01c0-1.187-.843-1.945-2.148-1.945h-1.074v-1.745h-1.161V235zm2.122-2.986c.655 0 1.074.403 1.074 1.026v.01c0 .623-.413 1.032-1.074 1.032h-.961v-2.068h.961zm6.659 2.986h1.16v-5.65h-1.16v2.277h-2.546v-2.277h-1.16V235h1.16v-2.455h2.546V235zm3.791.102c.752 0 1.402-.387 1.729-.994h.027V235h1.16v-3.894c0-1.133-.875-1.864-2.255-1.864-1.392 0-2.235.747-2.315 1.719l-.006.059h1.096l.011-.048c.096-.451.51-.768 1.181-.768.72 0 1.128.376 1.128.999v.424l-1.541.091c-1.338.081-2.1.682-2.1 1.665v.011c0 1.015.757 1.708 1.885 1.708zm-.714-1.735v-.011c0-.478.386-.784 1.085-.827l1.385-.086v.441c0 .736-.623 1.289-1.439 1.289-.623 0-1.031-.312-1.031-.806zm7.803 1.633h1.154v-5.65h-2.293c-1.321 0-2.181.73-2.181 1.901v.011c0 .784.484 1.369 1.268 1.6L257.269 235h1.322l1.364-1.939h.908V235zm-1.08-2.836c-.655 0-1.063-.376-1.063-.908v-.01c0-.613.402-.978 1.063-.978h1.08v1.896h-1.08zm7.587 2.949c1.617 0 2.68-1.117 2.68-2.938v-.011c0-1.81-1.074-2.922-2.68-2.922s-2.68 1.117-2.68 2.922v.011c0 1.815 1.058 2.938 2.68 2.938zm.006-.972c-.908 0-1.499-.715-1.499-1.966v-.011c0-1.235.596-1.95 1.493-1.95.903 0 1.499.715 1.499 1.95v.011c0 1.246-.586 1.966-1.493 1.966zm5.821.972c1.359 0 2.304-.87 2.428-2.004l.005-.037h-1.112l-.011.043c-.139.612-.59 1.026-1.305 1.026-.902 0-1.498-.725-1.498-1.961v-.005c0-1.209.585-1.961 1.488-1.961.757 0 1.187.468 1.31 1.021l.011.043h1.106l-.005-.038c-.097-1.063-.978-1.998-2.428-1.998-1.617 0-2.669 1.133-2.669 2.922v.005c0 1.81 1.031 2.944 2.68 2.944zm3.076-.113h2.235c1.305 0 2.148-.757 2.148-1.95v-.01c0-1.187-.843-1.945-2.148-1.945h-1.074v-1.745h-1.161V235zm2.122-2.986c.655 0 1.074.403 1.074 1.026v.01c0 .623-.413 1.032-1.074 1.032h-.961v-2.068h.961z"
      ></path>
      <rect width="430" height="256" x="0.5" y="0.5" stroke="#DCE0E5" rx="11.5"></rect>
      <defs>
        <linearGradient
          id="paint0_linear_6710_81466"
          x1="73.55"
          x2="73.55"
          y1="74.634"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_6710_81466"
          x1="96.68"
          x2="96.68"
          y1="92.366"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_6710_81466"
          x1="120.58"
          x2="120.58"
          y1="133.229"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_6710_81466"
          x1="143.71"
          x2="143.71"
          y1="70.779"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_6710_81466"
          x1="166.84"
          x2="166.84"
          y1="133.229"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint5_linear_6710_81466"
          x1="189.97"
          x2="189.97"
          y1="74.634"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint6_linear_6710_81466"
          x1="213.1"
          x2="213.1"
          y1="118.58"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint7_linear_6710_81466"
          x1="237"
          x2="237"
          y1="37.626"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint8_linear_6710_81466"
          x1="260.901"
          x2="260.901"
          y1="118.58"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint9_linear_6710_81466"
          x1="284.031"
          x2="284.031"
          y1="59.984"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint10_linear_6710_81466"
          x1="307.161"
          x2="307.161"
          y1="70.779"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint11_linear_6710_81466"
          x1="330.29"
          x2="330.29"
          y1="126.29"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint12_linear_6710_81466"
          x1="353.42"
          x2="353.42"
          y1="127.832"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint13_linear_6710_81466"
          x1="375.779"
          x2="375.779"
          y1="62.298"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#55A9E5"></stop>
          <stop offset="1" stopColor="#88A5F0"></stop>
        </linearGradient>
        <linearGradient
          id="paint14_linear_6710_81466"
          x1="82.55"
          x2="82.55"
          y1="124.634"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint15_linear_6710_81466"
          x1="105.68"
          x2="105.68"
          y1="142.366"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint16_linear_6710_81466"
          x1="130"
          x2="130"
          y1="133"
          y2="197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint17_linear_6710_81466"
          x1="152.71"
          x2="152.71"
          y1="120.779"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint18_linear_6710_81466"
          x1="176"
          x2="176"
          y1="158"
          y2="197"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint19_linear_6710_81466"
          x1="198.97"
          x2="198.97"
          y1="124.634"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint20_linear_6710_81466"
          x1="222.1"
          x2="222.1"
          y1="168.58"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint21_linear_6710_81466"
          x1="246"
          x2="246"
          y1="87.626"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint22_linear_6710_81466"
          x1="269.901"
          x2="269.901"
          y1="168.58"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint23_linear_6710_81466"
          x1="293.031"
          x2="293.031"
          y1="109.984"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint24_linear_6710_81466"
          x1="316.161"
          x2="316.161"
          y1="120.779"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint25_linear_6710_81466"
          x1="339.29"
          x2="339.29"
          y1="176.29"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint26_linear_6710_81466"
          x1="362.42"
          x2="362.42"
          y1="177.832"
          y2="197.221"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <linearGradient
          id="paint27_linear_6710_81466"
          x1="384.779"
          x2="384.779"
          y1="112.298"
          y2="197.222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#AF77BB"></stop>
          <stop offset="1" stopColor="#AC74B9"></stop>
        </linearGradient>
        <clipPath id="clip0_6710_81466">
          <path fill="#fff" d="M0 0H367.763V202H0z" transform="translate(32 33)"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default BarChartIcon;
